export enum userType {
    ADMIN = 'Admin',
    USER = 'User',
    SUPERADMIN = 'SuperAdmin'
}
